document.addEventListener('DOMContentLoaded', function () {
  var readMoreButtons = document.querySelectorAll('.richtext-with-background .readmore');
  var readLessButtons = document.querySelectorAll('.richtext-with-background .readless');
  readMoreButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
        e.preventDefault();
        var contentBlock = this.closest('.content-block');
        contentBlock.querySelector('.readmore-content').style.display = 'block';
        this.style.display = 'none';
        contentBlock.querySelector('.readless').style.display = 'inline';
    });
  });
  
  readLessButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
        e.preventDefault();
        var contentBlock = this.closest('.content-block');
        contentBlock.querySelector('.readmore-content').style.display = 'none';
        this.style.display = 'none';
        contentBlock.querySelector('.readmore').style.display = 'inline';
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var collectionBlocks = document.querySelector('.collection-blocks-outers.mobile_custom');  
  if(collectionBlocks){
    $(collectionBlocks).slick({
      dots: false,
      infinite: true,
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true
    });
  }
});


$(document).ready(function(){
 // $(".custom-collection-description").readmore({
 //  speed: 75, // how fast to animate
 //   collapsedHeight: 90,
 //   moreLink: '<a href="#" class="coll_read_more">Read more</a>',
 //  lessLink: '<a href="#" class="coll_read_less">Read less</a>',
 // });
}); 






// Popup read more
document.addEventListener("DOMContentLoaded", function () {
  const popupOverlay = document.getElementById("popupOverlay");
  const closePopup = document.getElementById("closePopup");
  const fullTextContainer = document.querySelector(".full-text");

  document.querySelectorAll(".read-more-btn").forEach(btn => {
    btn.addEventListener("click", function () {
      const fullText = this.getAttribute("data-full-text");
      fullTextContainer.innerHTML = fullText;
      popupOverlay.style.display = "block";
    });
  });

  closePopup.addEventListener("click", () => {
    popupOverlay.style.display = "none";
  });

  window.addEventListener("click", (e) => {
    if (e.target === popupOverlay) {
      popupOverlay.style.display = "none";
    }
  });
});